import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSelector } from "react-redux";
import { auth } from "../Services/FirebaseService";
import ApiService from "../Services/ApiService";
import { getActiveBrandConfig } from "../config/environment.config";

const GuestRoute = ({ children }: { children: React.ReactElement }) => {
  const currentUser = useSelector((state: any) => state.user.currentUser);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const location = useLocation();
  const currentRegister = useSelector(
    (state: any) => state?.user?.currentRegister
  );
  const route = getActiveBrandConfig();

  useEffect(() => {
    if (!currentUser?.isAuthenticated || !user) return;

    if (currentUser?.isTeachr) {
      const teachr = currentUser?.teachr;
      if (teachr && teachr.id) {
        const getTarget = (): string => {
          if (currentRegister === 3 && location.pathname === "/") {
            return `/${route}/tableau-de-bord/`;
          }
          if (currentRegister === 2 || currentRegister === 3) {
            return `/${route}/register`;
          }
          return location.pathname;
        };

        const target = getTarget();
        if (location.pathname !== target) {
          navigate(target);
        }
      } else {
        if (currentRegister === 2 && location.pathname !== `/${route}/register` && !teachr?.id) {
          navigate(`/${route}/register`);
        }
      }
    } else if (currentUser?.isClient) {
      // Espace client : un client connecté qui arrive sur une page prof est
      // ramené à son espace, sans couper son authentification
      if (!location.pathname.startsWith("/user")) {
        // navigate("/user/dashboard/accueil");
      }
    } else {
      ApiService.disableAuth();
      navigate("/");
    }
  }, [currentUser, user, currentRegister, route, navigate, location.pathname]);

  return children;
};

export default GuestRoute;
